import { msalInstance } from '@/configuration/auth/auth.configuration';
import navigationService from '@/services/NavigationService';
import '@/styles/index.scss';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import App from './App.vue';
import i18n from './configuration/i18n/i18n.configuration';
import router from './configuration/router';

async function init(): Promise<void> {
  Office.onReady(async () => {
    await msalInstance.initialize();
    const app = createApp(App);

    app.provide('msalInstance', msalInstance);

    // Set the router and navigation service
    navigationService.setRouter(router);

    const pinia = createPinia();
    app.use(router);
    app.use(i18n);
    app.use(pinia);

    app.mount('#app');
  });
}

init();
